import { LitElement, html, css } from 'lit-element';

class AppToolbar extends LitElement {
    constructor() {
        super();
    }

    static get properties() {
        return {};
    }

    static get styles() {
        return css`
            :host {
                align-items: center;
                display: grid;
                grid-template-columns: minmax(200px, max-content) minmax(120px, max-content) minmax(
                        40px,
                        auto
                    );
                gap: 0px;
            }

            :host([hidden]) {
                display: none;
            }
            :host ::slotted(*) {
                pointer-events: auto;
            }
            :host ::slotted([slot='right-menus']) {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                /* margin-right: 10px; */
            }
        `;
    }
    render() {
        return html`
            <slot name="main"></slot>
            <slot name="navigation"></slot>
            <slot name="right-menus"></slot>
        `;
    }
}
window.customElements.define('app-toolbar', AppToolbar);
